<template>
  <el-row
    v-if="config"
    :gutter="config.gutter"
    :justify="config.justifyContent"
    :align="config.alignItems"
    :style="rowStyle"
    type="flex"
    class="row-wrap"
  >
    <Col
      v-if="config.children && config.children.length"
      v-for="(item, colIdx) in config.children"
      :key="colIdx"
      :currentElementIndex="currentElementIndex"
      :allArcListMap="allArcListMap"
      :idx="colIdx"
      :listLength="config.children.length"
      :parentKeys="[...parentKeys, idx]"
      :disabled="disabled"
      :config="item.config"
    ></Col>
    <ClickConfigOverlay
      v-if="hasMeaningfulClickConfig(config.clickConfig)"
      :config="config.clickConfig"
    />
  </el-row>
</template>

<script setup>
import { computed } from 'vue';
import { useElementIndex } from './uses/elementIndexUse';
import Col from './Col.vue';
import ClickConfigOverlay from './common/ClickConfigOverlay.vue';

const props = defineProps({
  allArcListMap: { type: Object, default: () => ({}) },
  currentElementIndex: { type: Array, default: () => [] },
  idx: { type: Number, default: -1 },
  parentKeys: { type: Array, default: () => [] },
  disabled: { type: Boolean, default: true },
  config: { type: Object },
});

useElementIndex(props);

const hasMeaningfulClickConfig = (config) => {
  if (!config || !config.responseType) {
    return false;
  }
  if (config.responseType === 'link' || config.responseType === 'jumpLink') {
    return !!config.link;
  }
  if (config.responseType === 'popup') {
    return !!config.article || !!config.popupTitle || !!config.popupClass;
  }
  if (config.responseType === 'popoverPage') {
    return (
      !!config.popoverPageId ||
      !!config.popoverPageTitle ||
      !!config.popoverPageData
    );
  }
  return true;
};

const rowStyle = computed(() => {
  return {
    flexWrap: props.config.isNoWrap ? 'nowrap' : 'wrap',
    width: props.config.width ? `${props.config.width}px` : undefined,
    height: props.config.height ? `${props.config.height}px` : undefined,
  };
});
</script>

<style scoped>
.row-wrap {
  position: relative;
  background-size: 100% auto;
  background-position: center top;
}
</style>
